import React from 'react';
import styled from 'styled-components';
import '../../assets/fonts.css';

const LogoContainer = styled.div`
  align-items: baseline; /* Aligne les éléments sur leur ligne de base de texte */
`;

const Thinkfab = styled.span`
  font-family: var(--font-thinkfab);
  font-weight: 400;
  font-size: inherit;
  line-height: 1; /* Normalisation des lignes */
  letter-spacing: 0.10em;
`;

const Separator = styled.span`
  margin: 0 4px;
  font-family: var(--font-thinkfab);
  font-weight: 100;
  line-height: 1; /* Normalisation des lignes */
`;

interface ThinkfabLogoProps {
  className?: string;
  thinkfabColor?: string;
  separatorColor?: string;
  color?: string; // Fallback color for all parts
  size?: string;
  hideSeparator?: boolean;
}

const ThinkfabLogo: React.FC<ThinkfabLogoProps> = ({ 
  className, 
  thinkfabColor,
  separatorColor,
  color = 'inherit', 
  size = '24px',
  hideSeparator = false
}) => {
  // Use specific colors if provided, otherwise fall back to the general color
  const finalThinkfabColor = thinkfabColor || color;
  const finalSeparatorColor = separatorColor || color;

  return (
    <LogoContainer className={className} style={{ fontSize: size }}>
      <Thinkfab style={{ color: finalThinkfabColor }}>thinkfab</Thinkfab>
      {!hideSeparator && <Separator style={{ color: finalSeparatorColor }}>|</Separator>}
    </LogoContainer>
  );
};

export default ThinkfabLogo;